import request from '@/utils/request';

const baseURLAdmin = process.env.VUE_APP_ADMIN;

// LM损失定责-分页查询
export const lmLossResponsibilityPage = (data) => {
  return request({
    url: '/lmLossResponsibility/page',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// LM损失定责-统计查询
export const lmLossResponsibilityStatistics = (data) => {
  return request({
    url: '/lmLossResponsibility/statisticsQuery',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// LM损失定责-列表导出
export const lmLossResponsibilityExport = (data) => {
  return request({
    url: '/lmLossResponsibility/export',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// LM损失定责-批量导入
export const lmLossResponsibilityImport = (data) => {
  return request({
    url: '/lmLossResponsibility/batchImport',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// LM损失定责-修改责任网点
export const lmLossResponsibilityUpdateResponsibleBranch = (data) => {
  return request({
    url: '/lmLossResponsibility/updateResponsibleOutlets',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// LM损失定责-下拉选项
export const lmLossResponsibilityGetDropdownOptions = () => {
  return request({
    url: '/lmLossResponsibility/getDropdownOptions',
    method: 'get',
    baseURL: baseURLAdmin
  });
};
// FM定责-时效延误-分页查询
export const fmLiabilityPage = (data) => {
  return request({
    url: '/report/fmLiability/getTimelinessDetails',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// FM定责-时效延误-汇总查询
export const getTimelinessTotal = (data) => {
  return request({
    url: '/report/fmLiability/getTimelinessTotal',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// FM定责-时效延误-汇总查询
export const timelinessDetailsExport = (data) => {
  return request({
    url: '/report/fmLiability/timelinessDetailsExport',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// FM定责-丢失-分页查询
export const getLostPackagePageApi = (data) => {
  return request({
    url: '/report/fmLiability/getLostPackageTrackingDetails',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// FM定责-丢失-汇总查询
export const getLostPackageTrackingTotal = (data) => {
  return request({
    url: '/report/fmLiability/getLostPackageTrackingTotal',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
export const getAllCottageList = () => {
  // return request.get('/site/getAllCottageList');
  return request({
    url: '/site/getAllCottageList',
    method: 'get',
    baseURL: baseURLAdmin
  });
};
// FM定责-丢失-导出
export const lostPackageTrackingDetailsExport = (data) => {
  return request({
    url: '/report/fmLiability/lostPackageTrackingDetailsExport',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// 获取大区选项
export const lmLossResponsibilityGetRegionOptions = () => {
  return request({
    url: '/lmLossResponsibility/getRegionDropdownOptions',
    method: 'get',
    baseURL: baseURLAdmin
  });
};
// 获取网点所属州
export const lmLossResponsibilityGetStateOptions = (data) => {
  return request({
    url: '/area/getStateByRegion',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// 网点所属转运中心
export const lmLossResponsibilityGetTransferCenterOptions = (data) => {
  return request({
    url: '/site/getDepartmentByState',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// 根据州获取网点选项
export const getSiteByStateAndTypeApi = (data) => {
  return request({
    url: '/site/getSiteByStateAndType',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// 扣罚对账单  快递-分页查询
export const getLmPenaltyBillPage = (data) => {
  return request({
    url: '/lmPenaltyBill/page',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// 扣罚对账单  快递-导出
export const getLmPenaltyBillExport = (data) => {
  return request({
    url: '/lmPenaltyBill/export',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// 扣罚对账单  快递/服务商-明细汇总
export const getLmPenaltyBillSummary = (billNo) => {
  return request({
    url: `/lmPenaltyBill/detail/summary?billNo=${billNo}`,
    method: 'get',
    baseURL: baseURLAdmin
  });
};
// 扣罚对账单  快递/服务商-明细分页查询
export const getLmPenaltyBillDetailPage = (data) => {
  return request({
    url: '/lmPenaltyBill/detail/page',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// 扣罚对账单  快递/服务商-明细分页导出
export const detailExport = (data) => {
  return request({
    url: '/lmPenaltyBill/detailExport',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// 扣罚对账单  最终审核
export const lmPenaltyBillAudit = (data) => {
  return request({
    url: '/lmPenaltyBill/audit',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// 扣罚对账单  快递/服务商-修改截止时间
export const updateConfirmDeadline = (data) => {
  return request({
    url: '/lmPenaltyBill/updateConfirmDeadline',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// 扣罚对账单  快递  导出
export const lmPenaltyBillExport = (data) => {
  return request({
    url: '/lmPenaltyBill/export',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// 扣罚对账单  扣罚对账单详情/查看确认单
export const lmPenaltyBillInfo = (id) => {
  return request({
    url: `/lmPenaltyBill/billInfo/${id}`,
    method: 'get',
    baseURL: baseURLAdmin
  });
};
// 扣罚对账单  确认扣罚
export const confirmPenaltyBill = (data) => {
  return request({
    url: '/lmPenaltyBill/confirmPenaltyBill',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// 扣罚对账单  获取账期
export const lmPenaltyBillPeriod = () => {
  return request({
    url: `/lmPenaltyBill/billPeriod`,
    method: 'get',
    baseURL: baseURLAdmin
  });
};
// 批量修改扣罚状态
export const importForUpdateStatus = (data) => {
  return request({
    url: '/lmLossResponsibility/importForUpdateStatus',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// {
//   "errorFileUrl": "https://devgz-1313947203.cos.ap-guangzhou.myqcloud.com/upload/error_excel/a377d9c8967640a889095576285f6c4548e77505dd135f7285a1f02928bf327e/fine_status_import_error_20260706062921.xlsx?q-ak=AKIDnU2OXTBh1A6qMfkeNxNemhSjuwoT0O3f&q-signature=00ed4a8c5876dddcb063a78619d0c8aa3b76cb56",
//   "failCount": 6,
//   "successCount": 0,
//   "totalCount": 6
// }
// 汇总概览
export const getSummaryOverview = (data) => {
  return request({
    url: '/lmReconciliation/dashboard',
    data,
    method: 'post',
    baseURL: baseURLAdmin
  });
};
// 汇总概览
export const getSummaryPage = (data) => {
  return request({
    url: '/lmReconciliation/page',
    data,
    method: 'post',
    baseURL: baseURLAdmin
  });
};
// 明细-列表
export const getDetailList = (data) => {
  return request({
    url: '/lmReconciliation/detail',
    data,
    method: 'post',
    baseURL: baseURLAdmin
  });
};
// 明细-导出
export const getDetailListExport = (data) => {
  return request({
    url: '/lmReconciliation/detailExport',
    data,
    method: 'post',
    baseURL: baseURLAdmin
  });
};
// 大区条件
export const accessibleRegions = () => {
  return request({
    url: `/lmReconciliation/accessibleRegions`,
    method: 'get',
    baseURL: baseURLAdmin
  });
};
// 明细-状态统计
export const detailSummary = (data) => {
  return request({
    url: '/lmReconciliation/detailSummary',
    data,
    method: 'post',
    baseURL: baseURLAdmin
  });
};
// 明细-处理&批量处理
export const lmReconciliationProcess = (data) => {
  return request({
    url: '/lmReconciliation/process',
    data,
    method: 'post',
    baseURL: baseURLAdmin
  });
};
// 明细-详情
export const getDetailInfo = (id) => {
  return request({
    url: `/lmReconciliation/view/${id}`,
    method: 'get',
    baseURL: baseURLAdmin
  });
};
// 明细-最终审核&批量最终审核
export const lmReconciliationFinalDetermination = (data) => {
  return request({
    url: '/lmReconciliation/finalReview',
    data,
    method: 'post',
    baseURL: baseURLAdmin
  });
};
// 账期条件
export const accessiblePeriods = () => {
  return request({
    url: `/lmReconciliation/periods`,
    method: 'get',
    baseURL: baseURLAdmin
  });
};
